module.exports = __webpack_public_path__ + "static/media/apis-programming.bf701197.svg";